import api from '@/api/index';

const namespaced = true;

const state = {
  siteList: [],
  fileExport: {}
};

const getters = {
  siteList: (state) => state.siteList,
  fileExport: (state) => state.fileExport
};

const mutations = {
  SET_SITE_LIST: (state, payload) => {
    state.siteList = payload;
  },
  SET_FILE_EXPORT: (state, payload) => {
    state.fileExport = payload;
  }
};

const actions = {
  async fetchSite({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        ...payload
      }
      const { data } = await api.getSiteManagements(params);

      if (data.error) {
        commit('SET_SITE_LIST', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_SITE_LIST', data)
      commit('Table/SET_TOTAL_DATA', data.total ?? 0, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async postSite(_, payload) {
    try {
      await api.postSiteManagement(payload);
    } catch (error) {
      throw error.data;
    }
  },

  async putSite(_, payload) {
    try {
      await api.putSiteManagement(payload.id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },

  async deleteSite(_, payload) {
    try {
      await api.deleteSiteManagement(payload);
    } catch (error) {
      throw error.data;
    }
  },
  async downloadSite({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getSiteManagementsExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_FILE_EXPORT', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetFileExport({ commit }) {
    commit('SET_FILE_EXPORT', {})
  }
};

export default { namespaced, state, getters, mutations, actions };
